import React, { useMemo } from 'react';

import { ReportsLoading } from '../loading/reports-loading';

import { MessageError, MessageInfo } from './messages';
import './styles.scss';

interface BackgroundMessageProps {
  message?: { title: string; description?: string };
  isLoading?: boolean;
  labelLoading?: string;
  isNoLabelLoading?: boolean;
  button?: { title: string; onClick?: () => void };
  type?: 'info' | 'error';
  height?: string;
  top?: string;
  transparent?: boolean;
  classname?: string;
  icon?: React.ReactNode;
}

export const BackgroundMessage: React.FC<BackgroundMessageProps> = ({
  message,
  type = 'info',
  isLoading,
  labelLoading,
  isNoLabelLoading,
  button,
  height,
  top = '35px',
  transparent = false,
  classname,
  icon,
}) => {
  const renderMessage = useMemo(() => {
    switch (type) {
      case 'info':
        return <MessageInfo message={message} />;
      case 'error':
        return <MessageError message={message} button={button} icon={icon} />;
      default:
        return <MessageInfo message={message} />;
    }
  }, [type, icon, message]);

  return (
    <div
      className={`background-message-container ${transparent && 'transparent'} ${classname || ''}`}
      style={{ height: height ?? 'calc(100% - 90px)', marginTop: top }}
    >
      {isLoading ? (
        <ReportsLoading label={labelLoading} isNoLabel={isNoLabelLoading} />
      ) : (
        renderMessage
      )}
    </div>
  );
};
